<template>
    <DataTable v-redirect-if-no-permission:TYPES v-if="name" :url="api.ACTIONS.CAR_BRAND_MODELS(id)"
               :title='name + " - Models"'
               :fieldsHiddenMain="['deleted_at']"
               :fieldsHiddenAdd="['id','deleted_at','created_at','updated_at']"
               :fieldsDisabledEdit="['id','deleted_at','created_at','updated_at']"
               :fieldsExtraAdd="{name: 'v-text-field',number_of_seats: 'v-text-field'}"
               :titles="titles"
    ></DataTable>
</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";

    export default {
        name: "CarBrandModels",
        title: 'Models',
        components: {DataTable},
        data() {
            return {
                name: null,
                id: null,
            }
        },
        mounted() {
            this.id = this.$route.params.id;
            this.name = this.$route.query.name || "Unknown";
        },
        computed: {
            titles() {
                return {
                    id: "#",
                    number_of_seats: "Number of seats",
                    name: "Name",
                    created_at: "Created At",
                    updated_at: "Updated At"
                }
            }
        }
    }
</script>

<style scoped>

</style>